export default __webpack_public_path__ + "static/media/114.68993640.jpg";